export default {
    ["AUTH_REQUEST"]: (state) => {
        state.status = "loading";
    },
    ["AUTH_SUCCESS"]: (
        state,
        {
            token,
            claims,
            isAdmin,
            user,
            utaPhone,
            plivoPhone,
            emailAddress,
            name,
            branch,
            roles,
        },
    ) => {
        state.status = "success";
        state.token = token;
        state.user = user;
        state.claims = claims;
        state.roles = roles;
        state.isAdmin = isAdmin;
        state.utaPhone = utaPhone;
        state.emailAddress = emailAddress;
        state.plivoPhone = plivoPhone;
        state.name = name ? name : "";
        state.branch = branch;
    },
    ["CLAIMS"]: (state, claims) => {
        state.claims = Array.isArray(claims) ? claims.join(",") : claims;
    },
    ["AUTH_LOGOUT"]: (state) => {
        state.status = "";
        state.token = "";
        state.user = "";
        state.emailAddress = "";
        state.claims = "";
        state.isAdmin = "";
        state.utaPhone = "";
        state.plivoPhone = "";
        state.name = "";
        state.branch = "";
        state.roles = "";
    },
    ["AUTH_ERROR"]: (state) => {
        state.status = "error";
    },
};
